import { render, staticRenderFns } from "./MbeLegend.vue?vue&type=template&id=842e059e&scoped=true&"
import script from "./MbeLegend.vue?vue&type=script&lang=ts&"
export * from "./MbeLegend.vue?vue&type=script&lang=ts&"
import style0 from "./MbeLegend.vue?vue&type=style&index=0&id=842e059e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842e059e",
  null
  
)

export default component.exports